<template>
  <div class="c-single-img" :style="{'textAlign': textAlign}">
    <img class="c-single-img__img" :style="{'max-width': maxWidth}" :src="src" />
    <p class="c-single-label">{{label}}</p>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SingleImg',
  props: {
    src: {
      default: null,
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
    textAlign: {
      type: String,
      default: 'center',
    },
  },
});
</script>
<style lang="scss" scoped>
.c-single-img {
  margin: 10px 0;

  &__img {
    width: 100%;
  }
}

.c-single-label {
  margin-top: 10px;
  @include font-normal();
}
</style>
